export const settingsRu = {
  settings: {
    common: {
      save: 'Сохранить',
      add: 'Добавить',
      edit: 'Редактировать',
      cancel: 'Отмена',
    },
    page: {
      title: 'Настройки',
      subtitle: 'Управление настройками учётной записи и безопасностью',
      save: 'Сохранить',
      error_prefix: 'Ошибка загрузки настроек',
      sections: {
        preferences: {
          title: 'Предпочтения',
          description: 'Управление общими предпочтениями и настройками',
        },
        theme: {
          label: 'Тема',
          subtitle: 'Выберите светлую или тёмную тему',
          placeholder: 'Выберите тему',
          group_label: 'Тема',
          options: {
            light: 'Светлая',
            dark: 'Тёмная',
          },
        },
        locale: {
          label: 'Язык',
          subtitle: 'Язык, используемый в интерфейсе',
          placeholder: 'Выберите язык',
          group_label: 'Язык',
          options: {
            en: 'English',
            pl: 'Polski',
            ru: 'Русский',
          },
        },
        defaultContainersPublic: {
          label: 'Новые общины по умолчанию публичные',
          subtitle: 'При включении вновь созданные общины будут публичными по умолчанию',
        },
        profilePublic: {
          label: 'Сделать профиль публичным',
          subtitle: 'Разрешить другим аутентифицированным пользователям просматривать ваш публичный профиль',
        },
        emailPublic: {
          label: 'Показать email в публичном профиле',
          subtitle: 'Отображать ваш адрес email в публичном профиле (только если профиль публичный)',
        },
      },
    },
    security: {
      title: 'Безопасность',
      description: 'Управление безопасностью учётной записи и двухфакторной аутентификацией',
      setup: 'Включить 2FA',
      manage: 'Управление 2FA',
      login_required: 'Пожалуйста, войдите для управления настройками безопасности и двухфакторной аутентификацией.',
      not_configured: 'Двухфакторная аутентификация не включена. Включите её для повышения безопасности.',
      totp: {
        title: 'Приложение-аутентификатор',
        enabled: 'Включено',
        disabled: 'Не настроено',
      },
      passkeys: {
        title: 'Ключи доступа',
        enabled: 'Включено',
        disabled: 'Не настроено',
        count: 'Нет зарегистрированных ключей доступа | {count} ключ доступа зарегистрирован | {count} ключа доступа зарегистрировано | {count} ключей доступа зарегистрировано',
      },
      preferred_method: {
        title: 'Предпочтительный метод 2FA',
        description: 'Установите предпочтительный метод для двухфакторной аутентификации',
        label: 'Предпочтительный метод',
        placeholder: 'Выберите предпочтительный метод',
        options: {
          none: 'Автоматически',
          totp: 'Приложение-аутентификатор',
          webauthn: 'Ключи доступа',
        },
        saved: 'Предпочтительный метод обновлён',
        error: 'Не удалось обновить предпочтительный метод',
      },
    },
    preferences: {
      title: 'Настройки приложения',
      description: 'Управление настройками и предпочтениями приложения',
      save: 'Сохранить',
      saved: 'Сохранено',
      preferredWeightUnit: {
        label: 'Предпочтительная единица веса',
        subtitle: 'Единица по умолчанию для отображения весов во всём приложении',
        placeholder: 'Выберите единицу веса',
        options: {
          g: 'Граммы (г)',
          kg: 'Килограммы (кг)',
          oz: 'Унции (унц)',
          lb: 'Фунты (фунт)',
          'auto-g-kg': 'Авто (г/кг)',
          'auto-oz-lb': 'Авто (унц/фунт)',
        },
      },
      defaultCurrency: {
        label: 'Валюта по умолчанию',
        subtitle: 'Валюта по умолчанию для денежных значений в приложении',
        placeholder: 'Выберите валюту',
      },
      imageProcessingMode: {
        label: 'Режим обработки изображений',
        subtitle: 'Выберите способ обработки загруженных изображений (изменение размера и сжатие)',
        options: {
          highQuality: 'Высокое качество',
          highQualityDescription: 'Максимальный размер: 2560x2560px, качество JPEG: 95%. Лучшее качество, больший размер файла.',
          balanced: 'Сбалансированный',
          balancedDescription: 'Максимальный размер: 1200x1200px, качество JPEG: 90%. Хороший баланс между качеством и размером файла.',
          storageSaver: 'Экономия места',
          storageSaverDescription: 'Максимальный размер: 800x800px, качество JPEG: 80%. Меньший размер файла, более низкое качество.',
        },
      },
    },
    categories: {
      title: 'Пользовательские категории',
      description: 'Добавление и управление собственными категориями предметов',
      add: 'Добавить категорию',
      edit: 'Редактировать категорию',
      save: 'Сохранить',
      cancel: 'Отмена',
      deleteConfirm: 'Вы уверены, что хотите удалить эту категорию?',
      valuePlaceholder: 'Название категории',
      valueRequired: 'Название категории обязательно',
      empty: 'Пользовательских категорий пока нет. Добавьте первую выше.',
    },
    containerTypes: {
      title: 'Пользовательские типы контейнеров',
      description: 'Добавление и управление собственными типами контейнеров',
      add: 'Добавить тип контейнера',
      edit: 'Редактировать тип контейнера',
      save: 'Сохранить',
      cancel: 'Отмена',
      deleteConfirm: 'Вы уверены, что хотите удалить этот тип контейнера?',
      valuePlaceholder: 'Название типа контейнера',
      valueRequired: 'Название типа контейнера обязательно',
      empty: 'Пользовательских типов контейнеров пока нет. Добавьте первый выше.',
    },
    brands: {
      title: 'Пользовательские бренды',
      description: 'Добавление и управление собственными брендами предметов',
      add: 'Добавить бренд',
      edit: 'Редактировать бренд',
      save: 'Сохранить',
      cancel: 'Отмена',
      deleteConfirm: 'Вы уверены, что хотите удалить этот бренд?',
      valuePlaceholder: 'Название бренда',
      valueRequired: 'Название бренда обязательно',
      empty: 'Пользовательских брендов пока нет. Добавьте первый выше.',
    },
    oauth: {
      title: 'OAuth подключения',
      description: 'Управление связанными OAuth учётными записями (Google, Facebook и т.д.)',
      login_required: 'Пожалуйста, войдите для управления OAuth подключениями.',
      no_connections: 'Нет связанных OAuth учётных записей.',
      providers: {
        google: 'Google',
        facebook: 'Facebook',
      },
      connection: {
        linked: 'Подключено',
        deleted: 'OAuth подключение удалено',
        confirm_delete: 'Вы уверены, что хотите удалить подключение к {provider}?',
      },
    },
    storage: {
      title: 'Использование хранилища',
      description: 'Просмотр использования файлового хранилища и лимитов',
      used: 'Использовано',
      usagePercentage: 'Использование',
      error: 'Не удалось загрузить информацию о хранилище',
    },
    delete_account: {
      title: 'Удалить учётную запись',
      description: 'Безвозвратно удалить вашу учётную запись и все связанные данные',
      warning_title: 'Предупреждение: это действие нельзя отменить',
      warning_1: 'Все ваши данные будут безвозвратно удалены',
      warning_2: 'Вы потеряете доступ к общинам, группам и другим данным, связанным с учётной записью',
      warning_3: 'Это действие нельзя отменить',
      button: 'Удалить учётную запись',
      modal: {
        title: 'Удалить учётную запись',
        description: 'Вы уверены, что хотите удалить вашу учётную запись? Это действие нельзя отменить.',
        warning_title: 'Последнее предупреждение',
        warning_text: 'После удаления учётной записи все ваши данные будут безвозвратно удалены и не могут быть восстановлены.',
        confirmation_label: 'Введите DELETE для подтверждения',
        confirmation_hint: 'Пожалуйста, введите DELETE в поле выше для подтверждения удаления учётной записи',
        confirm_checkbox: 'Я понимаю, что это действие нельзя отменить и все мои данные будут безвозвратно удалены',
        cancel: 'Отмена',
        delete_button: 'Удалить учётную запись',
        success: 'Учётная запись успешно удалена',
        errors: {
          invalid_confirmation: 'Неверное подтверждение. Пожалуйста, введите DELETE для подтверждения.',
          generic: 'Не удалось удалить учётную запись. Пожалуйста, попробуйте снова.',
        },
      },
    },
  },
}
